import { jsx } from "react/jsx-runtime";
import { useState } from "react";
import { useMainMenuContext, useMainMenuTranslation } from "../../../../../hooks/index.js";
import MainMenuDrawer from "../../../../../ui/MainMenuDrawer.js";
import LazyLeftMenuDrawerContent from "./LazyLeftMenuDrawerContent.js";
const LeftMenuDrawer = (leftMenuDrawerProps)=>{
    const { t } = useMainMenuTranslation();
    const { activeSubMenu, onCloseSubmenu } = useMainMenuContext();
    const [activeDropdown, setActiveDropdown] = useState();
    const onDropwdownClose = ()=>{
        setActiveDropdown(void 0);
    };
    const onCategoriesDropdownOpen = ()=>{
        setActiveDropdown('catalog');
    };
    const onResourcesDropdownOpen = ()=>{
        setActiveDropdown('resources');
    };
    const onDegreesDropdownOpen = ()=>{
        setActiveDropdown('degrees');
    };
    const onBlogCategoriesDropdownOpen = ()=>{
        setActiveDropdown('blogCategories');
    };
    const onSolutionsDropdownOpen = ()=>{
        setActiveDropdown('solutions');
    };
    const onDismissLeftMenuDrawer = ()=>{
        onDropwdownClose();
        onCloseSubmenu();
    };
    return /*#__PURE__*/ jsx(MainMenuDrawer, {
        title: t('LEFT_MENU_TITLE'),
        isOpen: 'left-menu-drawer' === activeSubMenu,
        onDismiss: onDismissLeftMenuDrawer,
        position: "left",
        children: /*#__PURE__*/ jsx(LazyLeftMenuDrawerContent, {
            ...leftMenuDrawerProps,
            activeDropdown: activeDropdown,
            onDropwdownClose: onDropwdownClose,
            onCategoriesDropdownOpen: onCategoriesDropdownOpen,
            onResourcesDropdownOpen: onResourcesDropdownOpen,
            onDegreesDropdownOpen: onDegreesDropdownOpen,
            onBlogCategoriesDropdownOpen: onBlogCategoriesDropdownOpen,
            onSolutionsDropdownOpen: onSolutionsDropdownOpen,
            onDismissLeftMenuDrawer: onDismissLeftMenuDrawer
        })
    });
};
const LeftMenuDrawer_LeftMenuDrawer = LeftMenuDrawer;
export default LeftMenuDrawer_LeftMenuDrawer;
